import axios from 'axios'

export default new class ValidatorService {
  getList () {
    return axios.get('/validators')
  }

  get (validatorId) {
    return axios.get('/validators/' + validatorId)
  }
}()
